import { render, staticRenderFns } from "./ShareDemoModal.vue?vue&type=template&id=605602f0&"
import script from "./ShareDemoModal.vue?vue&type=script&lang=js&"
export * from "./ShareDemoModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareDemoModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports